// Local testing tools; the backend serves them only against a NetSuite sandbox account
export const devToolsMenu = [
  {
    path: "/dev-tools",
    name: "dev-tools.parent",
    redirect: "/dev-tools/outbound-event",
    icon: "tool",
    meta: {
      title: "Dev Tools",
      parentMenu: true,
      ability: { action: "create", subject: "Outbound" },
    },
    children: [
      {
        path: "/dev-tools/outbound-event",
        name: "dev-tools.outbound-event",
        icon: "send",
        component: () => import("@/views/devTools/OutboundEventDevTool.vue"),
        meta: {
          title: "Outbound Event",
          pageTitle: "Send Outbound Event",
          ability: { action: "create", subject: "Outbound" },
        },
      },
    ],
  },
];
